import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=e139d99a&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=e139d99a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e139d99a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e139d99a')) {
      api.createRecord('e139d99a', component.options)
    } else {
      api.reload('e139d99a', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=e139d99a&scoped=true&", function () {
      api.rerender('e139d99a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26jlLO5SEQX33/JS/comp/DocBox.vue"
export default component.exports